export default __webpack_public_path__ + "static/media/book-opened.87d6912a.png";